(ns frontend.view.metabase-dashboard.sub
  (:require
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::metabase-configs
 (fn [db [_ _]]
   (get-in db [::metabase-configs])))


(defn active-pipelines
  []
  (->> @session/oppo-pipelines
       (remove :pipeline/inactive?)
       (seq)))

(rf/reg-sub
 ::active-oppo-pipelines
 (fn [db _]
   (active-pipelines)))

(rf/reg-sub
 ::selected-pipeline-id
 (fn [db _]
   (get db ::selected-pipeline-id)))

(rf/reg-sub
 ::shown-pipeline-id
 :<-
 [::active-oppo-pipelines]
 :<-
 [::selected-pipeline-id]
 (fn [[active-pipelines selected-pipeline-id] _]
   (or selected-pipeline-id
       (->> active-pipelines
            (map :db/id)
            (first)))))

(rf/reg-sub
 ::pipeline-filtering?
 :<-
 [::metabase-configs]
 (fn [metabase-configs [_ report-id]]
   (get-in metabase-configs [report-id :pipeline-filtering?])))

(rf/reg-sub
 ::embed-url
 :<-
 [::metabase-configs]
 (fn [metabase-configs [_ report-id]]
   (get-in metabase-configs [report-id :dashboard-url])))
